import { api } from './_apiInterface';
import { pointer } from 'src/app-config';

class TranscriptionServices {
    private Base = pointer.transcription;
    //
    TranscribeFromBase64 = async (audioBase64: string) => {
        const data = await api.SendRequest<{ transcription: string; }>(this.Base, 'POST', { audioBase64 });
        return data;
    }
}

export const transcriptionServices = new TranscriptionServices();
